import { createFeatureSelector, createSelector } from '@ngrx/store';
import { IndexDesignerState } from '../reducers/indexdesigner.reducer';

export const indexDesignerState: any = createFeatureSelector<IndexDesignerState>('indexDesigner');

export const allIndices = createSelector(indexDesignerState, (state: any) => {
  return state.indexObjects;
});
export const indexNames = createSelector(indexDesignerState, (state: any) => {
  return state.indexNames;
});
export const indices = createSelector(indexDesignerState, (state: any) => {
  return state.indices;
});
export const saveSuccess = createSelector(indexDesignerState, (state: any) => {
  return state.savedIndex;
});
export const saveFailure = createSelector(indexDesignerState, (state: any) => {
  return state.error;
});
export const deletedSuccess = createSelector(indexDesignerState, (state: any) => {
  return state.deleteIndexId;
});

export const deleteFailure = createSelector(indexDesignerState, (state: any) => {
  return state.deleteError;
});
